var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../../libs/Model');
var verticalListItem = require('../../components/verticalListItem');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var permissionGroupFilter = require('../../libs/permissionGroupFilter');
var permissionGroupLoader = require('../../libs/permissionGroupLoader');

var permission = Object.create(Model)

permission.name = 'Permission';
permission['@class'] =  'Permission';
permission.url = 'permission';
permission.fields = {
  dashboard: {
    validators: {
      presence:true
    }
  },
  group: {
    validators: {
      presence: true
    }
  },
  read: {
    default: 0,
    validators: {}
  },
  write: {
    default: 0,
    validators: {}
  },
};

function isEnabled(value) {
  return Number(value) === 1;
}

function updateReadSelection(value) {
  permission.form.read(Number(value));
  if (!isEnabled(value)) {
    permission.form.write(0);
  }
}

function updateWriteSelection(value) {
  permission.form.write(Number(value));
  if (isEnabled(value)) {
    permission.form.read(1);
  }
}

permission.initForm = function (record) {
  permission.vm = Object.assign(permissionGroupLoader.createState(), {
    selectedGroup: prop({})
  });
  Model.initForm.call(permission, record);
  permission.form.groupsToShow = [];
  if(permission.form.group() && permission.form.group()['@rid']) {
    permission.form.group(permission.form.group()['@rid']); 
    permission.vm.newGroup = false;
  }
  else permission.vm.newGroup = true;
  if (isEnabled(permission.form.write())) {
    permission.form.read(1);
  }
  permission.loadGroups = function () {
    return permissionGroupLoader.load(permission.vm, function (groups) {
      return permissionGroupFilter.availableGroupsForPermission(groups, permission.record);
    });
  };
  permission.loadGroups();
};

permission.save = function () {
  if (isEnabled(permission.form.write())) {
    permission.form.read(1);
  }
  return Model.save.call(permission);
};

permission.view = function () {
  if (permission.vm.groupsError()) {
    return m('div.red', { role: 'alert' }, [
      m('div', permission.vm.groupsError()),
      m('button.mt3', { type: 'button', onclick: permission.loadGroups }, 'Retry')
    ]);
  }
  if (permission.vm.groupsLoading()) return m('div', 'Loading...');
  return m("form", {role: "form"}, [
    permission.errorView(),
    m("div.form-group",[
      m('label', 'Read'),
      m("select.form-control", {value: permission.form.read(), onchange: function(ev){updateReadSelection(ev.target.value)}}, [
        m("option", {value:0}, 'Disable'),
        m("option", {value:1}, 'Enable')
      ])
    ]),
    m("div.form-group",[
      m('label', 'Write'),
      m("select.form-control", {value: permission.form.write(), onchange: function(ev){updateWriteSelection(ev.target.value)}}, [
        m("option", {value:0}, 'Disable'),
        m("option", {value:1}, 'Enable')
      ])
    ]),
    
    permission.vm.newGroup ?
      m('div.mt2', [
        m(paginationWithSearch, {
          data: permission.vm.groups(),
          newNode: prop(false),
          dataToShow: permission.form.groupsToShow,
          placeHolder: 'Search group',
        },[
          permission.form.groupsToShow.map(function (group) {
            if(!group['@rid']) return;
            return m(verticalListItem, {onclick: permission.form.group.bind(this, group['@rid']), label: group.name}, [
              m('i', {class: 
                function getGroupIcon () {
                  var baseClass = 'fr ';
                  if (permission.form.group() === null) {return baseClass + 'ion-ios-circle-outline'};
                  if (permission.form.group() === group['@rid']) {
                    return baseClass + 'ion-ios-circle-filled'
                  }
                  else {
                    return baseClass + 'ion-ios-circle-outline' 
                  }
                }()
              })
            ])
          })
        ])
      ])
    :''
  ]);
};


module.exports = permission;
